/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different steps in the Assistant
 */
// eslint-disable-next-line no-shadow
enum Steps {
  TypeDeclaration = 0,
  SelectionPACS = 1,
  PACS = 2,
  Partenaire1 = 3,
  ParentsPartenaire1 = 4,
  Partenaire2 = 5,
  ParentsPartenaire2 = 6,
  DeclarationConvention = 7,
}

export default Steps;
